var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"title":_vm.modal.title,"width":1000,"destroyOnClose":""},on:{"ok":_vm.handleOk,"cancel":_vm.handleCancel},model:{value:(_vm.modal.visible),callback:function ($$v) {_vm.$set(_vm.modal, "visible", $$v)},expression:"modal.visible"}},[_c('UmsUser',{ref:"umsUser"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }